"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _formFields = require("@trodly/form-fields");

var _ActivityBased = _interopRequireDefault(require("./ActivityBased"));

var _LocationBased = _interopRequireDefault(require("./LocationBased"));

var _DateSelection = _interopRequireDefault(require("./DateSelection"));

var _actions = require("../actions");

var _baseModule = _interopRequireDefault(require("./styles/base.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EnquiryFor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EnquiryFor, _React$Component);

  function EnquiryFor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, EnquiryFor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EnquiryFor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "setEnquiryDetails", function (enquiry) {
      var setEnquiryFor = _this.props.setEnquiryFor;
      setEnquiryFor(enquiry);
    });

    _defineProperty(_assertThisInitialized(_this), "saveEnquiryDetails", function () {
      var _this$props = _this.props,
          nextStep = _this$props.nextStep,
          date = _this$props.date,
          enquiryFor = _this$props.enquiryFor;

      if (date.dateType && date.startDate && enquiryFor.queryType && enquiryFor.id) {
        nextStep();
      }
    });

    return _this;
  }

  _createClass(EnquiryFor, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          date = _this$props2.date,
          enquiryFor = _this$props2.enquiryFor,
          userDetails = _this$props2.userDetails,
          queryType = _this$props2.queryType;
      var nextAllowed = true;

      if (date.dateType && date.startDate && enquiryFor.queryType && enquiryFor.id) {
        nextAllowed = false;
      }

      return _react.default.createElement("div", {
        className: _baseModule.default.container
      }, _react.default.createElement("div", {
        className: "".concat(_baseModule.default.heading2, " ").concat(_baseModule.default.greenText)
      }, "Hello ", "".concat(userDetails.first_name || "there")), _react.default.createElement("div", {
        className: _baseModule.default.paragraph,
        style: {
          marginBottom: "1.25rem"
        }
      }, "Need help in planning your trip? Tell us more!"), queryType.queryType === "askQues" ? _react.default.createElement(_ActivityBased.default, {
        onSet: this.setEnquiryDetails
      }) : _react.default.createElement(_LocationBased.default, {
        onSet: this.setEnquiryDetails
      }), _react.default.createElement(_DateSelection.default, null), _react.default.createElement("div", {
        className: "".concat(_baseModule.default.displayFlex, " ").concat(_baseModule.default.justifyContentEnd),
        style: {
          margin: "1.25rem 0 1.25rem"
        }
      }, _react.default.createElement(_formFields.Button, {
        text: "Next",
        type: "button",
        primary: true,
        disabled: nextAllowed,
        onClick: this.saveEnquiryDetails
      })));
    }
  }]);

  return EnquiryFor;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userDetails: state.userDetails,
    date: state.date,
    enquiryFor: state.enquiryFor,
    queryType: state.queryType
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setDate: function setDate(date) {
      return dispatch((0, _actions.setDate)(date));
    },
    nextStep: function nextStep() {
      return dispatch((0, _actions.nextStep)());
    },
    setEnquiryFor: function setEnquiryFor(enquiry) {
      return dispatch((0, _actions.setEnquiry)(enquiry));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnquiryFor);

exports.default = _default;